/**
 * Ensure browser detection is aligned with browser detection in Base.BrowserDetection.
 * Changes made here need to be made in that file as well. Import statement does not work successfully.
 * \AzureUX-PortalFx\src\SDK\Website\TypeScript\MsPortalImpl\Base\Base.BrowserDetection.ts
 */
import * as BlobHelper from "../Helpers/BlobHelper";
import { cancel } from "../Helpers/ExecutionStatus";
const key = "browserInfo";
let diagnostics;
let browserInfo;
const global = window;
const { selfHelp: { resources } } = global;
const userAgent = window.navigator.userAgent;
// Searches user agent data to detect Edge Chromium
function isEdgeChromium() {
    let isChromium = false;
    let isEdge = false;
    if (navigator.userAgentData) {
        const { brands } = navigator.userAgentData;
        brands.forEach((item) => {
            if (item.brand === "Chromium") {
                isChromium = true;
            }
            if (item.brand === "Microsoft Edge") {
                isEdge = true;
            }
        });
        return isChromium && isEdge;
    }
    return false;
}
// FireFox's API contains InstallTrigger to detect add-on's
const ffFeature = typeof InstallTrigger !== "undefined";
// Opera contains window.opera, Opera 20+ contains window.opr && window.opr.addons
// Opera 15+ contains OPR in useragent
const operaFeature = (!!window.opr && !!window.opr.addons) || !!window.opera || navigator.userAgent.includes(" OPR/");
// Edge Chromium navigator.userAgentData contains brands with name "Chromium" and "Microsoft Edge"
const edgeChromiumFeature = isEdgeChromium();
// Chrome contains window.chrome, but have to detect that it is not Edge Chromium or Opera as both browsers contain this feature as well
const chromeFeature = (!!window.chrome && (!!window.chrome.webstore || !!window.chrome.loadTimes)) && !edgeChromiumFeature && !operaFeature;
// Microsoft Internet Explorer has property document.documentMode, Edge does not
// Conditional compilation tests for Microsoft Internet Explorer < 11
// eslint-disable-next-line no-constant-binary-expression -- Necessary for IE detection
const msieFeature = /*@cc_on!@*/ false || !!document.documentMode;
// Microsoft Edge contains window.StyleMedia, while Edge Chromium does not
const edgeFeature = !msieFeature && !!window.StyleMedia;
const safariUserAgent = /^(?!.*chrome).*safari/i.test(navigator.userAgent);
const chromeIosUserAgent = /CriOS/i.test(userAgent);
const isOpera = operaFeature;
const isSafari = safariUserAgent && !chromeIosUserAgent;
const isFirefox = ffFeature;
const isEdge = edgeFeature;
const isChromiumEdge = edgeChromiumFeature;
const isChrome = !!(chromeFeature || chromeIosUserAgent);
/**
 * Ends tests. Updates DOM and BLOB, ensures tests are not ran twice. If cancel has been clicked, will not
 * follow through with functionality.
 */
function endTest() {
    if (cancel) {
        return;
    }
    BlobHelper.updateBlob(key, diagnostics);
}
/**
 * Detects information about the browser via feature detection and updates the browserInfo object
 */
function detectBrowser() {
    try {
        if (isOpera) {
            return resources.Browser_opera;
        }
        if (isSafari) {
            return resources.Browser_safari;
        }
        if (isFirefox) {
            return resources.Browser_firefox;
        }
        if (msieFeature) {
            return resources.Browser_internetExplorer;
        }
        if (isEdge) {
            return resources.Browser_edge;
        }
        if (isChromiumEdge) {
            return resources.Browser_edgeChromium;
        }
        if (isChrome) {
            return resources.Browser_chrome;
        }
        return resources.Browser_unknown;
    }
    catch (err) {
        diagnostics = { success: false, details: err };
        endTest();
    }
}
/**
 * Detects the OS by parsing the User Agent
 */
function detectOS() {
    try {
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        const nVer = navigator.appVersion;
        let OSName = resources.OS_unknown;
        if (nVer.includes("Win")) {
            OSName = resources.OS_windows;
        }
        if (nVer.includes("Mac")) {
            OSName = resources.OS_mac;
        }
        if (nVer.includes("X11")) {
            OSName = resources.OS_unix;
        }
        if (nVer.includes("Linux")) {
            OSName = resources.OS_linux;
        }
        return OSName;
    }
    catch (err) {
        diagnostics = { success: false, details: err };
        endTest();
    }
}
/**
 * Calls functions to fetch browser information and constructs diagnostic object.
 */
function grabInfo() {
    browserInfo = {
        browserName: detectBrowser(),
        OSName: detectOS(),
        userAgent: navigator.userAgent,
    };
    diagnostics = {
        success: true,
        details: browserInfo,
    };
    endTest();
}
/**
 * Starts tests, updates DOM.
 */
export function startTest() {
    diagnostics = { success: null, details: null };
    grabInfo();
}
//# sourceMappingURL=BrowserDetector.js.map